const companyPopup = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-company-popup-link]').forEach((companyPopupLink) => {
            companyPopupLink.addEventListener('click', (event) => {
                event.preventDefault();
                if(!companyPopupLink.parentElement) return;
                const companyPopup = companyPopupLink.parentElement.querySelector('[data-company-popup]');
                if (!companyPopup) return;
                companyPopup.classList.add('company-popup--open');
            });
        });

        document.querySelectorAll('[data-company-popup-close]').forEach((companyPopupClose) => {
            companyPopupClose.addEventListener('click', (event) => {
                event.preventDefault();
                const companyPopup = companyPopupClose.closest('[data-company-popup]');
                if (!companyPopup) return;
                companyPopup.classList.remove('company-popup--open');
            });
        });
    });
};

export { companyPopup }